import { WorkInProgress } from "@/services/api";
import * as React from "react";
import { BarChart } from "../../molecules/Charts/BarChart";
import { IChartData } from "@/models/Charts/ChartData";
import _ from "lodash";
import Rand from "rand-seed";
export interface IRoTotalByInsuranceCompanyProps {
	wipItems: WorkInProgress[];
	loading?: boolean;
}

export function RoTotalByInsuranceCompany({ wipItems, loading }: IRoTotalByInsuranceCompanyProps) {
	const chartData = React.useMemo<IChartData>(() => {
		if (loading) {
			const labels = Array.from(Array(5).keys()).map((i, index) => {
				return "Insurance Company " + (i + 1);
			});
			const rand = new Rand("submitted");
			const cd: IChartData = {
				key: "loading-data",
				items: [
					{
						values: labels.map((i) => Math.round(rand.next() * 10)),
						color: "#eee",
					},
				],
				labels,
			};

			return cd;
		}

		const insuranceCompanies = _.uniq(wipItems.map((i) => i.insuranceCompany ?? "")).sort();

		const cd: IChartData = {
			items: [
				{
					values: insuranceCompanies.map<number>(
						(i) => wipItems.filter((j) => j.insuranceCompany === i).length
					),
				},
			],
			labels: insuranceCompanies,
		};

		return cd;
	}, [wipItems, loading]);

	return <BarChart title="WIP count by Insurance Company" data={chartData} />;
}
